"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _contract = _interopRequireDefault(require("./contract"));

var _TokenEmission = _interopRequireDefault([{
  constant: true,
  inputs: [],
  name: "name",
  outputs: [{
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x06fdde03"
}, {
  constant: false,
  inputs: [{
    name: "spender",
    type: "address"
  }, {
    name: "value",
    type: "uint256"
  }],
  name: "approve",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x095ea7b3"
}, {
  constant: true,
  inputs: [],
  name: "totalSupply",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x18160ddd"
}, {
  constant: false,
  inputs: [{
    name: "from",
    type: "address"
  }, {
    name: "to",
    type: "address"
  }, {
    name: "value",
    type: "uint256"
  }],
  name: "transferFrom",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x23b872dd"
}, {
  constant: true,
  inputs: [],
  name: "decimals",
  outputs: [{
    name: "",
    type: "uint8"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x313ce567"
}, {
  constant: false,
  inputs: [{
    name: "spender",
    type: "address"
  }, {
    name: "addedValue",
    type: "uint256"
  }],
  name: "increaseAllowance",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x39509351"
}, {
  constant: false,
  inputs: [{
    name: "to",
    type: "address"
  }, {
    name: "value",
    type: "uint256"
  }],
  name: "mint",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x40c10f19"
}, {
  constant: false,
  inputs: [{
    name: "value",
    type: "uint256"
  }],
  name: "burn",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x42966c68"
}, {
  constant: true,
  inputs: [{
    name: "owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x70a08231"
}, {
  constant: false,
  inputs: [{
    name: "from",
    type: "address"
  }, {
    name: "value",
    type: "uint256"
  }],
  name: "burnFrom",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x79cc6790"
}, {
  constant: true,
  inputs: [],
  name: "symbol",
  outputs: [{
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x95d89b41"
}, {
  constant: false,
  inputs: [{
    name: "account",
    type: "address"
  }],
  name: "addMinter",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x983b2d56"
}, {
  constant: false,
  inputs: [],
  name: "renounceMinter",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x98650275"
}, {
  constant: false,
  inputs: [{
    name: "spender",
    type: "address"
  }, {
    name: "subtractedValue",
    type: "uint256"
  }],
  name: "decreaseAllowance",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0xa457c2d7"
}, {
  constant: false,
  inputs: [{
    name: "to",
    type: "address"
  }, {
    name: "value",
    type: "uint256"
  }],
  name: "transfer",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0xa9059cbb"
}, {
  constant: true,
  inputs: [{
    name: "account",
    type: "address"
  }],
  name: "isMinter",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0xaa271e1a"
}, {
  constant: true,
  inputs: [{
    name: "owner",
    type: "address"
  }, {
    name: "spender",
    type: "address"
  }],
  name: "allowance",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0xdd62ed3e"
}, {
  inputs: [{
    name: "name",
    type: "string"
  }, {
    name: "symbol",
    type: "string"
  }, {
    name: "decimals",
    type: "uint8"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "account",
    type: "address"
  }],
  name: "MinterAdded",
  type: "event",
  signature: "0x6ae172837ea30b801fbfcdd4108aa1d5bf8ff775444fd70256b44e6bf3dfc3f6"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "account",
    type: "address"
  }],
  name: "MinterRemoved",
  type: "event",
  signature: "0xe94479a9f7e1952cc78f2d6baab678adc1b772d936c6583def489e524cb66692"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "from",
    type: "address"
  }, {
    indexed: true,
    name: "to",
    type: "address"
  }, {
    indexed: false,
    name: "value",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event",
  signature: "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    name: "spender",
    type: "address"
  }, {
    indexed: false,
    name: "value",
    type: "uint256"
  }],
  name: "Approval",
  type: "event",
  signature: "0x8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925"
}]);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Token = /*#__PURE__*/function (_Contract) {
  _inherits(Token, _Contract);

  function Token(web3, address) {
    _classCallCheck(this, Token);

    return _possibleConstructorReturn(this, _getPrototypeOf(Token).call(this, web3, _TokenEmission["default"], address));
  }

  _createClass(Token, [{
    key: "getInfo",
    value: function getInfo() {
      return Promise.all([this.methods.name().call(), this.methods.totalSupply().call(), this.methods.decimals().call(), this.methods.symbol().call()]).then(function (info) {
        return {
          name: info[0],
          totalSupply: Number(info[1]),
          decimals: Number(info[2]),
          symbol: info[3]
        };
      });
    }
  }]);

  return Token;
}(_contract["default"]);

exports["default"] = Token;